import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http
} from "@angular/http";
// import "rxjs/add/operator/map";
@Injectable()
export class RestMasterService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  //------------counter--------------//

  GetCounter(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Counter",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  SaveCounter(Counter_Master: any) {

    if (Counter_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Counter",
          Counter_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {

      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Counter",
          Counter_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  DeleteCounter(customDataFilter: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Counter",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-------------room-------------//
  GetRoom(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Room",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemLevel(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemLevel",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetRoomByType(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Room_ByType",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetRoomType(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RoomType",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveRoom(Room_Master: any) {
    if (Room_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Room",
          Room_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {

      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Room",
          Room_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }

  }
  DeleteRoom(customDataFilter: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Room",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


  //---------------table----------------//
  GetTableByRoomId(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Table_ByRoomId",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveTable(Table_Master: any) {

    if (Table_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Table",
          Table_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Table",
          Table_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteTable(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Table",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetTableForTableLayout(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_TableForTableLayout",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------provider--------------//
  GetProvider(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Providers",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      }

      )
  }
  SaveProvider(Provider_Master: any) {

    if (Provider_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Providers",
          Provider_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });

    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Providers",
          Provider_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteProvider(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Providers",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ProvidersList(body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ProvidersList",
        body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //----------------printer----------------//
  GetPrinter(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Printer",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SavePrinter(Printer_Master: any) {

    if (Printer_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Printer",
          Printer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Printer",
          Printer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeletePrinter(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Printer",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


  //--------------------room levels--------------------//

  GetSellingPriceRoomLevel(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_SellingPriceRoomLevel",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  SaveSellingPriceRoomLevel(Level_Master: any) {

    if (Level_Master.SPLId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_SellingPriceRoomLevel",
          Level_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {

      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_SellingPriceRoomLevel",
          Level_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  DeleteSellingPriceRoomLevel(customDataFilter: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_SellingPriceRoomLevel",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //----------------------sellingpriceroom------------------------------------//

  UpdateSellingPriceRoom(Room_Master: any) {
    return this.http
      .put(
        this.auth.baseUrl + "/services/api/rest/v1/Update_SellingPriceRoom",
        Room_Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


  //-- Category

  getCategory(FilterItems: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Categorys",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCategoryCode(CustomFilterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_GenerateCode",
        CustomFilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveCategory(RestCategory_Master: any) {

    if (RestCategory_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Category",
          RestCategory_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Category",
          RestCategory_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteCategory(CustomFilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Category",
        CustomFilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  // Employee
  deleteEmployee(CustomFilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Employee",
        CustomFilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  saveEmployee(RestEmployee_Master: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_Employee",
        RestEmployee_Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UpdateEmployee(RestEmployee_Master: any) {
    return this.http
      .put(
        this.auth.baseUrl + "/services/api/rest/v1/Update_Employee",
        RestEmployee_Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getEmployee(FilterItems: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Employee",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetCashierType(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetCashierType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getRestPosPrivilegeByUserId(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPosPrivilege_ByUserId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getRestPosPrivilegeActionsByUserId(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPosPrivilegeAction_ByUserId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getRestPosPrivilegeActionsByActionId(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPosPrivilegeAction_ByActionId",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveRestUserRights(Cashier: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestPosPrivilege",
        Cashier,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------privilege-----------------//

  //--------------Area-----------------//
  getArea(FilterItems: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CustomerArea",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveArea(RestCustomer_Master: any) {

    if (RestCustomer_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Area",
          RestCustomer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {

      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Area",
          RestCustomer_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  deleteArea(RestCustomer_Master: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Area",
        RestCustomer_Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Area-----------------//


  //--------------Predefined dicount-----------------//
  Get_pre_discount(FilterItems: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_PredefinedDiscount",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_pre_discount(Predefineddiscount_Master: any) {

    if (Predefineddiscount_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_PredefinedDiscount",
          Predefineddiscount_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {

      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_PredefinedDiscount",
          Predefineddiscount_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deletePreDisc(Predefineddiscount_Master: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Pre-Discount",
        Predefineddiscount_Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  /* getNextPreDiscId(LocationId: number) {
     return this.http
       .get(
         this.auth.baseUrl + "/services/api/rest/v1/Get_NextDiscountId?LocationId=" + LocationId,
         this.auth.getHeader()
       )
       .map(res => {
         return res.json();
       });
   }*/
  //--------------Predefined dicount-----------------//
  uploadFile(fileToUpload: File) {

    // const endpoint = 'your-destination-url';
    // const formData: FormData = new FormData();
    // formData.append('fileKey', fileToUpload, fileToUpload.name);
    // var xhr=new XMLHttpRequest
    // xhr.send(formData)
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/save_catimg?id=abc",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }



  getDailyrestsales(filterdata: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_dailysalesreport", filterdata,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetDailywiseSales(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Daywise_SalesReport",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      })

  }

  GetCategorywiseSales(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Categorywise_SalesReport",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      })

  }
  GetHourlySales(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Hourly_SalesReport",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      })

  }
  Get_Log(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_AllLog",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------currencyMaster-------------//
  GetCurrencyMaster(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CurrencyMaster",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveCurrencyMaster(CurrencyMaster: any) {
    if (CurrencyMaster.CurrencyId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_CurrencyMaster",
          CurrencyMaster,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_CurrencyMaster",
          CurrencyMaster,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteCurrencyMaster(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_CurrencyMaster",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


  //-------------------CurrencyDetails-----------------//

  GetCurrencyDetailsByCurrencyId(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CurrencyDetailsByCurrencyId",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveCurrencyDetails(CurrencyDetails: any) {
    if (CurrencyDetails.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_CurrencyDetails",
          CurrencyDetails,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_CurrencyDetails",
          CurrencyDetails,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteCurrencyDetails(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_CurrencyDetails",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-------------------Waiter--------------------//
  GetWaiter(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Waiter",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveWaiter(Waiter_Master: any) {
    if (Waiter_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Waiter",
          Waiter_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Waiter",
          Waiter_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  DeleteWaiter(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Waiter",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetStaffType(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_StaffType",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------------Waiter--------------------//
  listCustomer(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CustomerByPhone",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteCustomer(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Customer",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getRestCustomerSearch(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestCustomerSearch",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------------Kitchen Note--------------------//
  getKitchennote(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_AllKitchenNoteBackOffice",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteKitchennote(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/KitchenNote_DeleteBackOffice",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveKitchennote(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_KitchenNoteBackOffice",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateKitchennote(customDataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_KitchenNoteBackOffice",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------------Kitchen Note--------------------//
  //-------------------Table Layout--------------------//
  Get_Table_Layout(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Table_Layout",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_Update_TableLayout(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_Update_TableLayout",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_Table_forTableLayout(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_Table_forTableLayout",
        filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-------------------Table Layout--------------------//
  // ------------------html reports---------------------//
  GetHtmlReports(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_HtmlReports",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      })

  }
  Get_HtmlReports_FastMovingItems(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_HtmlReports_FastMovingItems",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      })

  }
  GetLocationByCompany(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetCompanyStecture",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // ------------------html reports--------------------//

  //...................settings------------------------//
  GetRestSettings(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestSettings",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  UpdateRestSettings(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_RestSettings",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }

  Send_TestMail(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Send_TestMail",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-------------------settings------------------------//
  //-------------------Show in menu update--------------------//
  getMenuItemsforStatusUpdate(DataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_MenuUpdateItems",
        DataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateShowinMenuStatus(DataFilter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_ShowinMenuStatus",
        DataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------------Show in menu update--------------------//
  // -----------Rest TypeCategory---------------
  get_TypeCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CategoryType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CategoryTypeForPreDisc(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CategoryTypeForPreDisc",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_TypeCategory(model: any) {
    if (model.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_CategoryType",
          model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_CategoryType",
          model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  delete_TypeCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_CategoryType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  get_TypeCategoryByType(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_TypeCategoryByType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_TypeList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_TypeList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_TypeListForReason(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetTypeListForReason",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Rest TypeCategory---------------
  // -----------Rest ModifierCategory---------------
  Save_ModifierCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_ModifierCategory",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ModifierCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_ModifierCategory",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_ModifierCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_ModifierCategory",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ModifierCategoryById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ModifierCategoryById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ModifierCategory(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ModifierCategory",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Rest ModifierCategory---------------
  // -----------Rest ITEMlEVEL---------------
  Get_ItemLevelList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemLevelList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveUpdate_ItemLevel(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/SaveUpdate_ItemLevel",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemLevelById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemLevelById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  delete_ItemLevel(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_ItemLevel",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Rest  iTEMlEVEL---------------
  //------------Rest TaxDetails---------------------------------------
  Get_TaxDetailsList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_TaxDetailsList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveUpdate_TaxDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/SaveUpdate_RestTaxDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_TaxDetailsById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestTaxDetailsById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_TaxDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_TaxDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------Rest TaxDetails---------------------------------------
  //------------Menu Migration---------------------------------------
  MenuMigration_copyItems(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/MenuMigration_copyItems",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------Menu Migration---------------------------------------
  //-----------------Rest Roles---------------------------------------
  Save_RestRoles(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestRoles",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestRolesById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestRolesById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestRoles(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestRoles",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_RestRoles(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_RestRoles",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-----------------Rest Roles------------------------------------
  //-----------------Rest User Roles------------------------------------
  Save_RestUserRoles(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestUserRoles",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestUserRolesById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestUserRolesById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_UserRestRoles(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_UserRestRoles",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_RestUserRoles(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_RestUserRoles",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestRolesForUserAction(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestRolesForUserAction",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestCashierForUserRole(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestCashierForUserRole",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------Rest User Roles------------------------------------
  //-----------------Rest Course Type------------------------------------
  Get_CourseTypeByLocId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CourseTypeByLocId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_CourseTypeMaster(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_CourseTypeMaster",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_CourseType(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CourseType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_CourseTypeMaster(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_CourseTypeMaster",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------Rest Course Type------------------------------------
  //-----------------Rest Room Printer Mapping---------------------------
  Get_ItemForRoomPrinterMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemForRoomPrinterMapping",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RoomsForRoomPrinterMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RoomsForRoomPrinterMapping",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_RoomPrinterMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RoomPrinterMapping",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------Rest Room Printer Mapping---------------------------

}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/restaurant/rest-master.service.ts